import React from 'react';
import { Text, View } from 'react-native';
import { useLocalSearchParams } from 'expo-router';
import ProjectActivationScreen from '../../../../components/onboarding/ProjectActivationScreen';
import { ProjectProvider } from '../../../../lib/ProjectContext';
import { Trans } from '@lingui/react/macro';
import { useSession } from '../../../../lib/SessionContext';
import { hasConfirmedEmailIdentity } from '../../../../utils/authHelpers';

export default function ProjectActivationRoute() {
    const { digestId, funnel_intent_id, activation_generation } = useLocalSearchParams<{
        digestId: string; funnel_intent_id?: string; activation_generation?: string;
    }>();
    const { session } = useSession();
    const projectId = Array.isArray(digestId) ? digestId[0] : digestId;
    const deferProjectAccess = hasConfirmedEmailIdentity(session)
        && Boolean(funnel_intent_id) && Number(activation_generation) > 0;

    if (!projectId) {
        return (
            <View>
                <Text><Trans id="digests.byDigestid.activate.noProjectIdProvided" comment="UI copy in app/(funnel)/digests/[digestId]/activate.tsx">No project ID provided</Trans></Text>
            </View>
        );
    }

    return (
        <ProjectProvider projectId={projectId} allowTransientNotFoundRetry deferProjectAccess={deferProjectAccess}>
            <ProjectActivationScreen />
        </ProjectProvider>
    );
}
